var $el, $ps, $up, totalHeight, pt;
$(".prod_description .buttons").on('click',function(e){
  e.preventDefault();
  $(".prod_box .button").trigger("click");

});



if ( $( ".checkbox-dropdown" ).length ) {
    $( "p.filter-title" ).show();
} else {
	$( "p.filter-title" ).hide();
}


$( '.warning--quantity' ).first().css( "display", "none" );

$(".prod_box .button").click(function() {
      
  totalHeight = 0

  $el = $(this);
  $pt  = $(".prod_description .buttons");
  $p  = $el.parent();
  $up = $p.parent();
  $ps = $up.find("p:not('.read-more')");
  
  // measure how tall inside should be by adding together heights of all inside paragraphs (except read-more paragraph)
  $ps.each(function() {
    totalHeight += $(this).outerHeight();
  });
        
  $up
    .css({
      // Set height to prevent instant jumpdown when max height is removed
      "height": $up.height(),
      "max-height": 9999
    })
    .animate({
      "height": totalHeight
    });
  
  // fade out read-more
  $p.fadeOut();
  $pt.fadeOut();
  
  // prevent jump-down
  return false;
    
});


$(document).ready(function() {


  $('.close-cart').click(function() {
    $('.cart_container').removeClass('active_link');
  });

  $.get(
    "https://www.googleapis.com/youtube/v3/search",{
      part : 'snippet', 
      channelId : 'UCSECma_Q4Z8fdUsCSVCcYdQ', // You can get one from Advanced settings on YouTube
      type : 'video',
      order: 'date',
      maxResults : '10',
      key: 'AIzaSyDIRrK2RzT0vEN3kJlTzM28PZVzf6HBh04'},
      function(data) {
        $.each( data.items, function( i, item ) {
          $('#purepearls_channel').append(
          '<div class="videolist">' +
          '<div class="videolist-border">' +
          '<iframe width="100%" height="100%" src="https://www.youtube.com/embed/' + item.id.videoId + '?rel=0&amp;showinfo=0" frameborder="0" allowfullscreen style="border:0;"></iframe>' +
          ' </div>' +
          ' </div>'
          );
        })
      })
      .done(function() {
          $('#purepearls_channel').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: false,
            dots: false,
            infinite: false,
            adaptiveHeight: true,
            prevArrow: '<button type="button" class="slick-prev"><img src="//www.purepearls.com/cdn/shop/t/153/assets/prevarrow.png?v=173185151204216444271790015305"/></button>',
            nextArrow: '<button type="button" class="slick-next"><img src="//www.purepearls.com/cdn/shop/t/153/assets/nextarrow.png?v=132694277941045835271790015305"/></button>',
            arrows: true,
            responsive: [
              {
                breakpoint: 799,
                settings: {
                  slidesToShow: 1
                }
              }
            ]
          });
      }
  );

  $('.pearl-slider')
  .on('afterChange init', function(event, slick, direction){
    //slick.$slides.removeClass('prev-slide').removeClass('next-slide');
    $('.slick-slide').removeClass('prev-slide').removeClass('next-slide');

      // find current slide
      for (var i = 0; i < slick.$slides.length; i++)
      {
          var $slide = $(slick.$slides[i]);
          if ($slide.hasClass('slick-current')) {
              // update DOM siblings
              $slide.prev().addClass('prev-slide');
              $slide.next().addClass('next-slide');
              break;
          }
      }
    }
  )
  .on('beforeChange', function(event, slick) {
     //slick.$slides.removeClass('prev-slide').removeClass('next-slide');
     $('.slick-slide').removeClass('prev-slide').removeClass('next-slide');
  })
  .slick({
   //slidesToShow: 5,
    slidesToScroll: 1,
    dots:false,
    centerMode: true,
    centerPadding: '40px',
    variableWidth: true,
    adaptiveHeight: false,
	focusOnSelect: true,
    asNavFor: '.pearl-slider-asnav',
    prevArrow: '<button type="button" class="slick-prev"><img class="lazyload" data-src="//www.purepearls.com/cdn/shop/t/153/assets/prev-pearl.png?v=163084703714115839391790015305"/></button>',
    nextArrow: '<button type="button" class="slick-next"><img class="lazyload" data-src="//www.purepearls.com/cdn/shop/t/153/assets/next-pearl.png?v=43047007025169331951790015305"/></button>',
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: true,
          centerPadding: '5px',
          slidesToShow: 1
        }
      }
    ]
  });

  $('.pearl-slider-asnav').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    adaptiveHeight: false,
    asNavFor: '.pearl-slider',
  });

  if(template === 'index'){
    $('#pearl_expert_blog').slick({
      rows: 2,
      slidesToShow: 2,
      autoplay: false,
      prevArrow: '<button type="button" class="slick-prev"></button>',
      nextArrow: '<button type="button" class="slick-next"></button>',
      arrows: true,
      responsive: [
        {
          breakpoint: 1700,
          settings: {
            rows: 1,
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            rows: 1,
            slidesToShow: 1
          }
        }
      ]
    });
  } else {
    $('#pearl_expert_blog').slick({
      slidesToShow: 2,
      slidesToScroll: 2,
      autoplay: false,
      dots: false,
      infinite: true,
//       adaptiveHeight: true,
      variableWidth: false,
      prevArrow: '<button type="button" class="slick-prev"></button>',
      nextArrow: '<button type="button" class="slick-next"></button>',
      arrows: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }



  $('#sub-listholder-carousel').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    dots: true,
    infinite: false,
    adaptiveHeight: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1199,
        settings: "unslick"
      }
    ]
  });

//   $('.vertical-menu.float_left').find('li:nth-child(2)').before(
//     `<li>
//       <div class="search__container" data-autocomplete-true>
//         <form id="nav-search" class="search search__form" action="/search">
//           <div class="search__wrapper">
//             
//               <input type="hidden" name="type" value="product" />
//             
//             <input type="text" name="q" placeholder="" value="" x-webkit-speech autocapitalize="off" autocomplete="off" autocorrect="off" class="search-bar"/>
//           </div>
//           <div class="search__results-wrapper" style>
//           <ul class="search__results"></ul>
//         </div>
//         </form>
//       </div>
//     </li> 
//     `
// );
$('.vertical-menu.float_left').find("li a:contains('Help')").addClass('center-item').prepend('<span class="help-icon"><img src="//www.purepearls.com/cdn/shop/t/153/assets/help-icon.png?v=118748864974774815711790015305" alt=""></span>');

$('.footer_content .help_title').click(function(){
  $('.footer_content .toggle_help_content').toggleClass('show_help');
});


  var $el, $ps, $up, totalHeight;

$(".product-para-details .button").click(function() {
      
  totalHeight = 0

  $el = $(this);
  $p  = $el.parent();
  $up = $p.parent();
  $ps = $up.find("p:not('.read-more-details')");
  
  // measure how tall inside should be by adding together heights of all inside paragraphs (except read-more paragraph)
  $ps.each(function() {
    totalHeight += $(this).outerHeight();
  });
        
  $up
    .css({
      // Set height to prevent instant jumpdown when max height is removed
      "height": $up.height(),
      "max-height": 9999
    })
    .animate({
      "height": totalHeight
    });
  
  // fade out read-more
  $p.fadeOut();
  
  // prevent jump-down
  return false;
    
});
  
  

  
//slick product gallery carousel -   
// $(".product_gallery_nav").slick({
//     slidesToShow: 3,
//     slidesToScroll: 1,
//    infinite: true,
//     mobileFirst: true,
//     prevArrow: false,
//     nextArrow: $(".nn2"),
//     responsive: [{
//         breakpoint: 500,
//         settings: {
//             slidesToShow: 2
//         }
//     }]
// });
  
//$("#btn-next").click(function() {
// $(".product_gallery_nav .next").trigger('click');
//  return false;
//});

$('.carousel').flickity({
  groupCells: true, 
  groupCells: 3,
  contain: true,
  pageDots: false,
  wrapAround: true
});
  
thumbnails = $('img[src*="/products/"]').not(':first');
  if (thumbnails.length) {
    thumbnails.bind('click', function() {
      var arrImage = $(this).attr('src').split('?')[0].split('.');
      var strExtention = arrImage.pop();
      var strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/,'');
      var strNewImage = arrImage.join('.')+"."+strRemaining+"."+strExtention;
    });
  }
});

if ($('#shopify-section-product-template').length) {
  var thumbsCount = $('.product_gallery_nav').find('.gallery-cell').length,
      draggable,
      prevNext,
      wrapAround;
  
  if(thumbsCount > 3) {
     draggable = true;
     prevNext = true;
     wrapAround = true;
  } else {
     draggable = false;
     prevNext = false;
     wrapAround = false;
  }
     
  $('.product_gallery_nav').flickity({
    "wrapAround" : wrapAround,
     "draggable": draggable,
     "prevNextButtons": prevNext,
     "contain": "true",
     "cellAlign": "left",
     "pageDots": false,
     "watchCSS": true
  });
}


setTimeout(function() { 
  if($('.yotpo').length) {
    var api = new Yotpo.API(yotpo);
    api.refreshWidgets();
  }
}, 500);


/* Product Info Tab group
================================================== */

// Info tabs visibility
$(".tab input").on("click", setTabHeight);
function setTabHeight(e) {
  let x = $(".tab__content");
  
  x.each(() => {
    x.css({
      visibility: "hidden",
      opacity: 0
    })
  });
  
  $(".tab__content:eq("+ $(".tab input").index(this) +")").css({
    visibility: "visible",
    opacity: 1
  });
}
$('.tab').first().find('input').prop('checked', true);


/* Sticky header margin-top .main_nav_wrapper.sticky_nav.sticky_nav--stick
================================================== */
let segunoBanner = '.__seguno-banner-container';

let waitForEl = function(selector, callback) {
  if ($(selector).length) {
    $('.__seguno-close-container').on('click', function(){
      $('.main_nav_wrapper.sticky_nav').css("margin-top", '0');
    });
    callback();
  } else {
    setTimeout(function() {
      waitForEl(selector, callback);
    }, 100);
  }
};

let set_segunoBanner_height = function() {
  $('.main_nav_wrapper.sticky_nav').css("margin-top", $(segunoBanner).outerHeight());
}

waitForEl(segunoBanner, set_segunoBanner_height);


/* Update Product Retail Price on swatch change
================================================== */

if ($("#js_change_price").length) {
  console.log("here")
  // select the target node
  let target = $("#js_change_price")[0]
  // create an observer instance
  let callback = function(mutations) {
    computePriceOnchange()
  }
  const observer = new MutationObserver(callback);
  // configuration of the observer:
  let config = {  attributes: true, childList: true, characterData: true };
  // pass in the target node, as well as the observer options
  observer.observe(target, config);
}
 
let format = function(price){
  let str = price.toString().replace("$", ""), parts = false, output = [], i = 1, formatted = null;
  if(str.indexOf(".") > 0) {
    parts = str.split(".");
    str = parts[0];
  }
  str = str.split("").reverse();
  for(let j = 0, len = str.length; j < len; j++) {
    if(str[j] != ",") {
      output.push(str[j]);
      if(i%3 == 0 && j < (len - 1)) {
        output.push(",");
      }
      i++;
    }
  }
  formatted = output.reverse().join("");
  return("$" + formatted + ((parts) ? "." + parts[1].substr(0, 2) : ""));
};

function computePriceOnchange() {
  let clean_orig_price = parseInt($("#js_change_price").text().replace("$", "").replace(",", ""));

  // Pure Pearls (Retail Price)
  $("#js_our_price_onchange").text(format( Math.round(clean_orig_price) ));
  $("#js_our_price_onchange_mobile").text(format( Math.round(clean_orig_price) ));

  // Online “Discount” Sellers (Retail Price)
  $("#js_online_price_onchange").text(format( Math.round(clean_orig_price - (clean_orig_price * 0.15)) ))
  $("#js_online_price_onchange_mobile").text(format( Math.round(clean_orig_price - (clean_orig_price * 0.15)) ))

  // Traditional Luxury Retail (Retail Price)
  $("#js_luxury_price_onchange").text(format( Math.round(clean_orig_price * 4) ))
  $("#js_luxury_price_onchange_mobile").text(format( Math.round(clean_orig_price * 4) ))

  // Pure Pearls (Cost)
  $("#js_our_price_cost").text(format( Math.round(clean_orig_price * 0.8) ))
  $("#js_our_price_cost_mobile").text(format( Math.round(clean_orig_price * 0.8) ))

  // Online “Discount” Sellers (Cost)
  $("#js_online_price_cost").text(format( Math.round((clean_orig_price - (clean_orig_price * 0.15)) * 0.6) ));
  $("#js_online_price_cost_mobile").text(format( Math.round((clean_orig_price - (clean_orig_price * 0.15)) * 0.6) ));

  // Traditional Luxury Retail (Cost)
  $("#js_luxury_price_cost").text( format(  Math.round((clean_orig_price * 0.8) + 50) ) )
  $("#js_luxury_price_cost_mobile").text( format(  Math.round((clean_orig_price * 0.8) + 50) ) )
}


$(document).ready(function() {
  $("#JS_redirect_banner").click(function() {
    window.location = "https://www.purepearls.com"+$("#JS_redirect_banner").data("location"), true;
    console.log("https://www.purepearls.com"+$("#JS_redirect_banner").data("location"));
    return false;
  });
});